import { render } from "./videoControl.vue?vue&type=template&id=55fe6436&scoped=true"
import script from "./videoControl.vue?vue&type=script&lang=js"
export * from "./videoControl.vue?vue&type=script&lang=js"

import "./videoControl.vue?vue&type=style&index=0&id=55fe6436&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fe6436"]])

export default __exports__